/**
 * Route for `device-masking-detection-emulator-modified-rom-roo`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { DeviceMaskingDetectionEmulatorModifiedRomRooPage } from "../features/device-masking-detection-emulator-modified-rom-roo/DeviceMaskingDetectionEmulatorModifiedRomRooPage";

export const deviceMaskingDetectionEmulatorModifiedRomRooRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/device-masking-detection-emulator-modified-rom-roo",
	component: DeviceMaskingDetectionEmulatorModifiedRomRooPage,
});

export default deviceMaskingDetectionEmulatorModifiedRomRooRoute;
